import { Form, message } from 'antd';
import styles from './searchGroup.less?modules';
import SingInputML from '@/components/input_all_ml/form_sing_input_ml/SingInputML';
import ButtonML from '@/components/button_ml/ButtonML';
import SelectML from '@/components/select_ml/SelectML';
import { toOption } from '@/utils/comUtil.js';
import { fieldPackageStatus } from '@/constants.js';
import { useTrigger } from '@/utils/comHook.js';
import ModalML from '@/components/modal_ml/ModalML';
import EditModal from '@/containers/edit_modal/EditModal';
import { useDispatch, useSelector } from 'dva';

const formList = [
  {
    name: 'name',
    type: 'input',
    label: '字段包名',
    required: true,
  },
  {
    name: 'description',
    type: 'input',
    label: '描述',
    required: true,
  },
  {
    name: 'fieldStatus',
    type: 'select',
    label: '状态',
    required: true,
    option: toOption(fieldPackageStatus),
  },
];
const SearchGroup = (props) => {
  const { fetchData } = props;
  const [form] = Form.useForm();
  const trigger = useTrigger();
  const dispatch = useDispatch();
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['cfpm/addFieldPackage'];
  const onFinish = (values) => {
    for (let key in values) {
      if (!values[key]) {
        values[key] = undefined;
      }
    }
    dispatch({
      type: 'cfpm/setSearchValue',
      payload: {
        values,
      },
    });
  };
  const onReset = () => {
    form.resetFields();
  };
  const editSingleFieldPackage = (value) => {
    dispatch({
      type: 'cfpm/addFieldPackage',
      payload: {
        values: {
          ...value,
        },
      },
      callback: (response) => {
        if (response.code === 0) {
          message.success('新增成功');
          fetchData();
          trigger.close();
        } else {
          message.error(response.message);
        }
        // responseMsgTips({
        //   response: response,
        //   customMsg: response?.message ? response?.message : '新增成功',
        //   onSuccess: () => {
        //     fetchData();
        //     trigger.close();
        //   },
        // });
      },
    });
  };

  return (
    <Form
      form={form}
      name="cfpm-search"
      onFinish={onFinish}
      className={styles.serarchFrom}
    >
      {/* 字段包名 */}
      <div className={styles.input_contain}>
        <SingInputML
          height="37px"
          labelwidth="130px"
          inputWidth="269px"
          labelVal="字段包名"
          placeVal="请输入字段包名"
          name="name"
          allowClear={true}
          // icon={}
        />

        {/* 状态 */}
        <SelectML
          height="37px"
          labelwidth="130px"
          inputWidth="269px"
          labelVal="状态"
          placeVal="请选择状态"
          name="fieldPackageStatus"
          allowClear={true}
          option={toOption(fieldPackageStatus)}
          // icon={}
        />
      </div>

      <div className={styles.btn_contain}>
        <ButtonML
          size="large"
          value="查询"
          htmlType="submit"
          // width="106px"
          // height="46px"
          fontsize="16px"
        />
        <ButtonML
          size="large"
          value="重置"
          // width="106px"
          // height="46px"
          fontsize="16px"
          onClick={onReset}
        />
        <ButtonML
          size="large"
          value="新增"
          // width="106px"
          // height="46px"
          fontsize="16px"
          onClick={trigger.open}
        />
      </div>
      <ModalML
        title="新增"
        handleOk={trigger.open}
        handleCancel={trigger.close}
        visible={trigger.visible}
        // visible={true}
      >
        <EditModal
          handleCancel={trigger.close}
          edit={editSingleFieldPackage}
          formList={formList}
          loading={loading}
        />
      </ModalML>
    </Form>
  );
};

export default SearchGroup;
